import { Coupon } from '@src/types/coupon';
import { getIssuedCouponListApi, issueCouponApi } from './company';
import { ChangeStatusParams, CouponListParams } from './coupons';
import { oliveApi } from '../index';

const url = `/admin/v1/coupons`;

const createCouponApi = async (data: Coupon) => {
  return await oliveApi.POST<Coupon, any>(`${url}`, data);
};

const updateCouponApi = async (id: string, data: Coupon) => {
  return await oliveApi.PATCH<Coupon, any>(`${url}/${id}`, data);
};

const getCouponsListApi = async (params: CouponListParams) => {
  return await oliveApi.GET<CouponListParams, any>(`${url}`, params);
};

const getCouponApi = async (id: string) => {
  return await oliveApi.GET<string, any>(`${url}/${id}`);
};

const changeCouponStatusApi = async ({ id, status }: ChangeStatusParams) => {
  return await oliveApi.PATCH<ChangeStatusParams, any>(
    `${url}/${id}/${status}`
  );
};

const deleteCouponApi = async (id: string) => {
  return await oliveApi.DELETE<string, any>(`${url}/${id}`);
};

export {
  createCouponApi,
  updateCouponApi,
  getCouponsListApi,
  getCouponApi,
  changeCouponStatusApi,
  deleteCouponApi,
  getIssuedCouponListApi,
  issueCouponApi,
};
